import React from 'react';
import { icons } from '~/assets';
import Button from '~/components/button';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Select from '~/components/select';
import { IDocumentTypes } from '~/models/proposal';

interface DocumentUploadDialogProps {
  open: boolean;
  formTypeDoc: string;
  selectedDocumentFile: any;
  documentTypes: Array<IDocumentTypes> | undefined;
  inputRef: React.RefObject<HTMLInputElement>;
  onClose: () => void;
  onDocumentTypeChange: (value: string) => void;
  onSelectFile: () => void;
  onSubmit: () => void;
}

const DocumentUploadDialog: React.FC<DocumentUploadDialogProps> = ({
  open,
  formTypeDoc,
  selectedDocumentFile,
  documentTypes,
  inputRef,
  onClose,
  onDocumentTypeChange,
  onSelectFile,
  onSubmit,
}) => {
  return (
    <Dialog
      icon={icons.exclamation}
      open={open}
      negativeLabel="Cancelar"
      negativeAction={onClose}
      positiveLabel="Fazer upload"
      positiveAction={onSubmit}
      message="Upload de documento"
      buttonDisabledPositive={!selectedDocumentFile || !formTypeDoc}
    >
      <ContainerFlex row padding={12}>
        <ContainerFlex marginRight={10}>
          <Select
            label="Tipo de documento"
            value={formTypeDoc}
            options={documentTypes?.map((e) => ({
              id: e?.id,
              value: e?.nome,
            }))}
            onChange={(e) => onDocumentTypeChange(e)}
          />
        </ContainerFlex>
        <ContainerFlex marginRight={10}>
          <Button size="medium" onClick={onSelectFile}>
            Selecionar Documento
          </Button>
        </ContainerFlex>
      </ContainerFlex>
      <ContainerFlex row padding={12}>
        {selectedDocumentFile && <span>{selectedDocumentFile?.name}</span>}
      </ContainerFlex>
    </Dialog>
  );
};

export default DocumentUploadDialog;
